import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '_metronic/layout/core'
import { MedicamentosListWrapper } from './medicamentos-list/MedicamentosList'
import { useT } from '_metronic/i18n/Metronici18n'

const MedicamentosPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.medicamentos.descricao')}>
                {t('menu.medicamentos')}
              </PageTitle>
              <MedicamentosListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default MedicamentosPage
